import { render, staticRenderFns } from "./RateAgentDetails.vue?vue&type=template&id=0afec5fb&scoped=true&"
import script from "./RateAgentDetails.vue?vue&type=script&lang=js&"
export * from "./RateAgentDetails.vue?vue&type=script&lang=js&"
import style0 from "./RateAgentDetails.vue?vue&type=style&index=0&id=0afec5fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afec5fb",
  null
  
)

export default component.exports